<div class="charity-details-container">
  <!-- Header with charity information -->
  <div class="details-header">
    <span class="charity-info">{{organizationName || 'New Charity'}} | {{address || 'Address not set'}} | {{orgId || 'New'}} | {{ccn || 'CCN not set'}}</span>
    <div class="header-actions">
      <button class="status-btn" [class.active]="client">{{client ? 'Active' : 'Status'}}</button>
      <button class="status-btn active">Active</button>
    </div>
  </div>

  <!-- Main Content with Left Tabs -->
  <div class="main-content">
    <!-- Left Side Tabs -->
    <div class="left-tabs">
      <button 
        class="left-tab" 
        [class.active]="activeTab === 'organization'"
        (click)="setActiveTab('organization')">
        Organisation
      </button>
      <button 
        class="left-tab" 
        [class.active]="activeTab === 'contacts'"
        (click)="setActiveTab('contacts')">
        Contacts
      </button>
    </div>

    <!-- Right Side Content -->
    <div class="right-content">
      
      <!-- Organization Tab Content -->
      <div class="tab-content" *ngIf="activeTab === 'organization'">
        <form class="details-form">
          
          <!-- Organization Name Section -->
          <div class="org-name-section">
            <div class="org-name-field">
              <label class="form-label">Organisation Name</label>
              <input type="text" class="form-input" [(ngModel)]="organizationName" name="organizationName" />
            </div>
          </div>

          <!-- Organization Details Grid - Compact -->
          <div class="compact-grid">
            <div class="form-row">
              <label class="form-label">Org ID</label>
              <input type="text" class="form-input" [(ngModel)]="orgId" name="orgId" />
            </div>
            <div class="form-row">
              <label class="form-label">CCN</label>
              <input type="text" class="form-input" [(ngModel)]="ccn" name="ccn" />
            </div>
            <div class="form-row">
              <label class="form-label">Address</label>
              <input type="text" class="form-input" [(ngModel)]="address" name="address" />
            </div>
            <div class="form-row">
              <label class="form-label">Client</label>
              <input type="checkbox" class="form-checkbox" [(ngModel)]="client" name="client" />
            </div>
          </div>

          <!-- Charitable Activity -->
          <div class="form-row compact">
            <label class="form-label">Charitable Activity</label>
            <select class="form-select compact" [(ngModel)]="charitableActivity" name="charitableActivity">
              <option value="ComboBox">ComboBox</option>
              <option value="Healthcare">Healthcare</option>
              <option value="Education">Education</option>
              <option value="Social Services">Social Services</option>
            </select>
          </div>

          <!-- Parent Org -->
          <div class="form-row compact">
            <label class="form-label">Parent Org</label>
            <select class="form-select compact" [(ngModel)]="parentOrg" name="parentOrg">
              <option value="ComboBox">ComboBox</option>
              <option value="Independent">Independent</option>
              <option value="Group Member">Group Member</option>
            </select>
          </div>

          <!-- Child Orgs and Alternative Names Side by Side -->
          <div class="textarea-row">
            <div class="form-row">
              <label class="form-label">Child Orgs</label>
              <textarea class="form-textarea compact" [(ngModel)]="childOrgs" name="childOrgs" rows="4"></textarea>
            </div>
            <div class="form-row">
              <label class="form-label">Alternative Names</label>
              <textarea class="form-textarea compact" [(ngModel)]="alternativeNames" name="alternativeNames" rows="4"></textarea>
            </div>
          </div>

          <!-- Services Section -->
          <div class="services-section">
            <h3 class="section-title">Services</h3>
            
            <div class="form-row compact">
              <label class="form-label">S&F Tier</label>
              <select class="form-select compact" [(ngModel)]="safTier" name="safTier">
                <option value="ComboBox">ComboBox</option>
                <option value="Tier 1">Tier 1</option>
                <option value="Tier 2">Tier 2</option>
                <option value="Tier 3">Tier 3</option>
              </select>
            </div>

            <div class="services-table-container">
              <table class="services-grid">
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Invoicing</th>
                    <th>Subscribed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let service of services; let i = index">
                    <td>{{service.service}}</td>
                    <td>{{service.invoicing}}</td>
                    <td>
                      <input 
                        type="checkbox" 
                        [(ngModel)]="service.subscribed" 
                        [name]="'service_' + i" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>

      <!-- Contacts Tab Content -->
      <div class="tab-content" *ngIf="activeTab === 'contacts'">
        <div class="contacts-section">
          
          <!-- Show contacts table only in edit mode -->
          <div *ngIf="isEditMode" class="contacts-table-container">
            <table class="contacts-table">
              <thead>
                <tr>
                  <th>Contact Name</th>
                  <th>Email</th>
                  <th>Address</th>
                  <th>Invoice Email</th>
                  <th>Notifications Email</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let contact of contacts">
                  <td>{{contact.contactName}}</td>
                  <td>{{contact.email}}</td>
                  <td>{{contact.address}}</td>
                  <td>{{contact.invoiceEmail}}</td>
                  <td>{{contact.notificationsEmail}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <!-- Empty state for Add New mode -->
          <div *ngIf="!isEditMode" class="empty-contacts">
            <p class="empty-message">No contacts yet. Add contacts for this new charity.</p>
          </div>
          
          <div class="contacts-actions">
            <button class="btn btn-secondary" (click)="onAddNewContact()">Add New</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Action Buttons -->
  <div class="bottom-actions">
    <button class="btn btn-secondary" (click)="onDeleteAccount()">Delete Account</button>
    <button class="btn btn-secondary" (click)="onSuspend()">Suspend</button>
    <button class="btn btn-primary" (click)="onSave()">Save</button>
  </div>
</div>
